import { render } from "./BaloonPlayer.vue?vue&type=template&id=8e356ce4&scoped=true"
import script from "./BaloonPlayer.vue?vue&type=script&lang=js"
export * from "./BaloonPlayer.vue?vue&type=script&lang=js"

import "./BaloonPlayer.vue?vue&type=style&index=0&id=8e356ce4&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e356ce4"]])

export default __exports__